import { Tooltip } from '@mui/material';
import { columnInfoLookup } from './columnInfo';

import * as S from './styles';

import { ColumnHeaders } from './types';

interface HeaderCellProps {
  accessor?: ColumnHeaders;
  text?: React.ReactNode;
  description?: NonNullable<React.ReactNode>;
  align?: React.CSSProperties['textAlign'];
  multiline?: boolean;
}

const HeaderCell: React.FunctionComponent<HeaderCellProps> = ({
  accessor,
  text,
  description,
  align,
  multiline,
}) => {
  if (!accessor) {
    return <S.HeaderCellWrapper>{text}</S.HeaderCellWrapper>;
  }
  const colInfo = columnInfoLookup[accessor];
  const renderedDescription = description ?? colInfo.description;
  const renderedText = text ?? colInfo.text;

  return (
    <S.HeaderCellWrapper $multiline={multiline} textAlign={align}>
      {renderedText}
      {renderedDescription && (
        <Tooltip title={renderedDescription}>
          <S.InfoIcon color="info" fontSize="small" />
        </Tooltip>
      )}
    </S.HeaderCellWrapper>
  );
};
export default HeaderCell;
